import React from 'react';
import {connect} from 'react-redux';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Button, Grid, Form, Card, Icon} from 'semantic-ui-react';
import {
  TextAreaField,
  TextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import _ from 'lodash';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {validDate} from 'common/utils';
import {generateTimeId} from 'framework/collaboration/collaboration.utils';
import {checkIfIncludedsIn} from 'common/utils';
import {isRequired, maxLength, minLength} from 'go/components/rules/rules';
import {Contexts} from 'componentLibrary';
import {produceAppliedDiff} from 'framework/collaboration/diff.utils';
const {RequestDetailsContext} = Contexts;
const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  NONE: 'none',
};

const MAX_LENGTHS = {
  MILESTONE_NAME: 100,
  MILESTONE_ADDITIONAL_INFO: 4000,
};
export class AddMilestone extends React.Component {
  static contextType = RequestDetailsContext;
  constructor(props) {
    super(props);
    this.state = {
      openModal: MODALS.NONE,
      addMilestone: false,
      selectedIndex: -1,
      selectedId: '',
      milestoneNameError: false,
      milestoneDateError: false,
      additionalInfoError: false,
      nameHasChanged: true,
    };
  }

  milestoneNameErrorMessage = 'Please enter a unique milestone name.';
  milestoneDateErrorMessage = 'Please enter a date';
  milestoneDateErrorMessage = 'You must enter a valid date';
  additionalInfoErrorMessage = 'Your response must be 4000 characters or less';
  milestoneHeader = 'Milestones';

  validateName = (name, maxSize) => {
    let NameList = this.getMilestoneNames();
    if (this.state.openModal === MODALS.EDIT && !this.state.nameHasChanged) {
      return isRequired()(name) && minLength(1)(name) && maxLength(maxSize)(name);
    }
    return (
      isRequired()(name) &&
      minLength(1)(name) &&
      maxLength(maxSize)(name) &&
      !checkIfIncludedsIn(NameList, _.toUpper(name))
    );
  };
  validateMilestoneDate = (milestoneDate) => {
    return validDate(milestoneDate, 'MM/DD/YYYY');
  };
  validateAdditionalInfo = (additionalInfo, maxSize) => {
    return minLength(1)(additionalInfo) && maxLength(maxSize)(additionalInfo);
  };
  handleMilestoneNameOnBlur = () => {
    this.setState({
      milestoneNameError: !this.validateName(
        _.trim(this.state.addMilestone.milestoneName),
        MAX_LENGTHS.MILESTONE_NAME
      ),
    });
  };
  handleMilestoneDateOnBlur = () => {
    if (!!this.state.addMilestone.milestoneDate) {
      this.setState({
        milestoneDateErrorMessage: 'You must enter a valid date',
        milestoneDateError: !this.validateMilestoneDate(
          this.state.addMilestone.milestoneDate
        ),
      });
    } else {
      this.setState({
        milestoneDateErrorMessage: 'Please enter a response',
        milestoneDateError: true,
      });
    }
  };
  handleAdditionalInfoOnBlur = () => {
    this.setState({
      additionalInfoError: !this.validateAdditionalInfo(
        this.state.addMilestone.additionalInfo,
        MAX_LENGTHS.MILESTONE_ADDITIONAL_INFO
      ),
    });
  };

  validateMilestone = () => {
    const {addMilestone} = this.state;
    let milestone = this.getMilestone();
    Promise.all([
      this.handleMilestoneNameOnBlur(),
      this.handleMilestoneDateOnBlur(),
      this.handleAdditionalInfoOnBlur(),
    ]).then(() => {
      if (
        !this.state.milestoneNameError &&
        !this.state.milestoneDateError &&
        !this.state.additionalInfoError
      ) {
        milestone.push(addMilestone);
        this.updateMilestone(milestone);
      }
    });
  };

  handleCreateMilestoneButton() {
    this.setState({
      openModal: MODALS.CREATE,
      addMilestone: {},
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.currentlyCollaborating) {
      const {selectedId, addMilestone} = this.state;
      if (selectedId && addMilestone) {
        const getPropMilestones = (pr) =>
          _.get(pr, `data.${_.get(pr, 'sourcePath')}.milestones`);
        let prevSelected = _.filter(
          getPropMilestones(prevProps),
          (m) => m.id === selectedId
        )[0];
        let currentSelected = _.filter(
          getPropMilestones(this.props),
          (m) => m.id === selectedId
        )[0];
        if (prevSelected && !currentSelected) {
          // remote deleted this, but someone is editing, so prefer the editor and ignore
        } else {
          this.state.addMilestone = produceAppliedDiff(
            prevSelected,
            currentSelected,
            this.state.addMilestone
          );
        }
      }
    }
  }

  getMilestone = () => {
    // Clone data under the 'milestones' field in the root entityDataPath.
    let sourcePath = _.get(this.props, 'sourcePath');
    let savedMilestone = _.get(
      this.props,
      'data.' + sourcePath + '.milestones',
      undefined
    );
    if (savedMilestone != null) {
      savedMilestone = _.orderBy(
        savedMilestone,
        [(obj) => new Date(obj.milestoneDate)],
        ['asc']
      );
    }
    return _.map(savedMilestone, (milestone) => {
      if (this.props.currentlyCollaborating) {
        const milestoneCopy = {...milestone};
        milestoneCopy.id = milestoneCopy.id || generateTimeId();
        return milestoneCopy;
      } else {
        return milestone;
      }
    });
  };

  getMilestoneNames = () => {
    let milestonNames = [];
    let milestones = this.getMilestone();
    _.forEach(milestones, (milestone) => {
      if (!_.isNull(milestone)) {
        milestonNames.push(_.toUpper(milestone.milestoneName));
      }
    });
    return milestonNames;
  };

  updateMilestone = (milestone) => {
    const {saveEntityData, validationId, entityDataPath, entityType} = this.props;
    let sourcePath = _.get(this.props, 'sourcePath');
    const milestoneEntityDataPath = entityDataPath + '.' + sourcePath;
    let included = _.concat(milestone);
    if (this.props.currentlyCollaborating) {
      included = included.map((m) => {
        let milestoneCopy = {...m};
        milestoneCopy.id = milestoneCopy.id || generateTimeId(milestoneCopy);
        return milestoneCopy;
      });
    }
    this.setState({
      openModal: MODALS.NONE,
    });
    // Save data to the 'milestones' field under the root entityDataPath.
    const fieldName = 'milestones';
    saveEntityData(
      milestoneEntityDataPath + '.' + fieldName,
      entityType,
      included,
      validationId + '.' + fieldName
    );
  };

  handleCancelAction = () => {
    this.setState({
      openModal: MODALS.NONE,
      milestoneNameError: false,
      milestoneDateError: false,
      additionalInfoError: false,
    });
  };

  renderCreateMilestoneModal() {
    let {addMilestone} = this.state;
    if (addMilestone) {
      return (
        <FemaGoModal
          title="Add Milestone"
          size="small"
          open={this.state.openModal === MODALS.CREATE}
          buttonText="Save milestone"
          confirmAction={(e) => {
            this.validateMilestone();
          }}
          cancelAction={this.handleCancelAction}
          disableButton={
            this.state.milestoneNameError ||
            this.state.milestoneDateError ||
            this.state.additionalInfoError
          }
        >
          {this.renderMilestoneForm()}
        </FemaGoModal>
      );
    }
  }
  renderMilestoneForm = () => {
    const {addMilestone} = this.state;

    const handleInputChange = (e) => {
      let {name, value} = e.target;
      const addMilestone = {...this.state.addMilestone, [name]: value};
      this.setState({addMilestone});
    };
    return (
      <React.Fragment>
        <Form>
          <TextBoxField
            title="Milestone name"
            label="Milestone name"
            id="milestoneName"
            name="milestoneName"
            maxLength={MAX_LENGTHS.MILESTONE_NAME}
            value={addMilestone.milestoneName}
            handleChange={handleInputChange}
            handleBlur={this.handleMilestoneNameOnBlur}
            displayError={this.state.milestoneNameError}
            errorMessages={this.milestoneNameErrorMessage}
          />
          <TextBoxField
            title="Milestone Date"
            label="Milestone Date (MM/DD/YYYY)"
            id="milestoneDate"
            name="milestoneDate"
            size="small"
            value={addMilestone.milestoneDate}
            handleChange={handleInputChange}
            handleBlur={this.handleMilestoneDateOnBlur}
            displayError={this.state.milestoneDateError}
            errorMessages={this.milestoneDateErrorMessage}
          />
          <TextAreaField
            type="text"
            id="additionalInfo"
            name="additionalInfo"
            title="Additional Information"
            label="Additional Information"
            width={8}
            optional={true}
            style={{minHeight: 100}}
            value={addMilestone.additionalInfo}
            handleChange={handleInputChange}
            handleBlur={this.handleAdditionalInfoOnBlur}
            displayError={this.state.additionalInfoError}
            errorMessages={this.additionalInfoErrorMessage}
          />
        </Form>
      </React.Fragment>
    );
  };

  renderEditMilestoneModal() {
    const {currentlyCollaborating} = this.props;
    const {addMilestone, selectedIndex, selectedId} = this.state;
    let milestone = this.getMilestone();
    if (
      !currentlyCollaborating &&
      milestone !== undefined &&
      selectedIndex > -1 &&
      selectedIndex < milestone.length
    ) {
      this.state.nameHasChanged = !_.isEqual(
        _.toUpper(this.state.addMilestone.milestoneName),
        _.toUpper(milestone[selectedIndex].milestoneName)
      );
    } else if (currentlyCollaborating) {
      this.state.nameHasChanged = !_.isEqual(
        _.toUpper(this.state.addMilestone.milestoneName),
        _.toUpper(milestone.filter((m) => m.id === selectedId)[0]?.milestoneName)
      );
    }
    return (
      <FemaGoModal
        title="Edit milestone"
        size="large"
        open={this.state.openModal === MODALS.EDIT}
        buttonText="Update milestone"
        confirmAction={(e) => {
          Promise.all([
            this.handleMilestoneNameOnBlur(),
            this.handleMilestoneDateOnBlur(),
            this.handleAdditionalInfoOnBlur(),
          ]).then(() => {
            if (
              !this.state.milestoneNameError &&
              !this.state.milestoneDateError &&
              !this.state.additionalInfoError
            ) {
              if (currentlyCollaborating) {
                const newMilestones = milestone.filter((m) => m.id !== selectedId);
                newMilestones.push(addMilestone);
                this.updateMilestone(newMilestones);
                return;
              }
              milestone[selectedIndex] = addMilestone;
              this.updateMilestone(milestone);
            }
          });
        }}
        cancelAction={this.handleCancelAction}
        disableButton={
          this.state.milestoneNameError ||
          this.state.milestoneDateError ||
          this.state.additionalInfoError
        }
      >
        {addMilestone ? this.renderMilestoneForm() : null}
      </FemaGoModal>
    );
  }

  handleRemoveMilestone = (index, selectedId) => {
    if (this.props.currentlyCollaborating) {
      let milestone = this.getMilestone().filter((m) => m.id !== selectedId);
      this.updateMilestone(milestone);
      return;
    }
    let milestone = this.getMilestone();
    milestone.splice(index, 1);
    this.updateMilestone(milestone);
  };
  render() {
    const {currentlyCollaborating} = this.props;
    const readOnly = !_.get(this.props, 'editable', false);
    const hideButtons = _.get(this.context, 'customizations.hideButtons', false);
    let milestone = this.getMilestone();
    return (
      <div className="margin-top--standard margin-bottom--standard">
        <div className="accordion-subhead-block w-clearfix">
          {!hideButtons && !readOnly ? (
            <Button
              id="add milestone button"
              as="a"
              basic
              primary
              small
              href="#"
              title="Add a milestone"
              className="app-button_secondary white float-right w-button"
              onClick={() => this.handleCreateMilestoneButton()}
            >
              <span class="fa-link-lg-btn">
                <Icon name="add" />
              </span>{' '}
              Add a milestone
            </Button>
          ) : null}
          {!_.isEmpty(milestone) && (
            <h5 className="apph5 accordion-subhead">{this.milestoneHeader}</h5>
          )}
        </div>
        {milestone &&
          _.map(milestone, (sMilestone, index) => (
            <Card fluid="true" key={currentlyCollaborating ? `${sMilestone.id}` : index}>
              <Grid celled="internally" fluid="true">
                <Grid.Column width={4}>
                  <Grid>
                    <Grid.Column>
                      <strong>{`Milestone name`}</strong>
                      <div>{sMilestone.milestoneName}</div>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Grid>
                    <Grid.Column>
                      <strong>Milestone date</strong>
                      <div> {sMilestone.milestoneDate}</div>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Grid>
                    <Grid.Column>
                      <strong>Additional information</strong>
                      <div>{sMilestone.additionalInfo}</div>
                    </Grid.Column>
                  </Grid>
                </Grid.Column>
                {!readOnly && !hideButtons ? (
                  <Grid.Column width={2}>
                    <Grid columns={4}>
                      <Grid.Column width="10">
                        <a
                          href={`#${index}`}
                          id={index}
                          onClick={() =>
                            this.setState({
                              addMilestone: sMilestone,
                              selectedId: sMilestone.id,
                              selectedIndex: index,
                              openModal: MODALS.EDIT,
                            })
                          }
                        >
                          <Icon name="pencil" />
                          Edit
                        </a>
                      </Grid.Column>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.handleRemoveMilestone(index, sMilestone.id);
                        }}
                      >
                        <Icon link name="close" color="red" />
                        Delete
                      </a>
                    </Grid>
                  </Grid.Column>
                ) : null}
              </Grid>
            </Card>
          ))}
        {this.renderCreateMilestoneModal()}
        {this.renderEditMilestoneModal()}
      </div>
    );
  }
}
export const mapStateToProps = (state) => ({
  currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
});

export default connect(mapStateToProps)(connectDynamic(AddMilestone));
